import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { AppProvider, useApp } from './contexts/AppContext';
import { PreferencesProvider } from './contexts/PreferencesContext';
import { TutorialProvider } from './contexts/TutorialContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppLoadingScreen from './components/AppLoadingScreen';
import NotificationContainer from './components/ui/NotificationContainer';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ConfirmEmail from './pages/ConfirmEmail';
import CheckYourEmail from './pages/CheckYourEmail';
import Dashboard from './pages/Dashboard';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import CompleteProfile from './pages/CompleteProfile';

function AuthRedirect() {
  const { state } = useApp();

  if (state.isAuthenticating) {
    return <AppLoadingScreen />;
  }

  return state.user ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <Navigate to="/signin" replace />
  );
}

function AppRouter() {
  return (
    <Router>
      <Routes>
        {/* Root redirect */}
        <Route path="/" element={<AuthRedirect />} />

        {/* Auth routes */}
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />
        <Route path="/check-your-email" element={<CheckYourEmail />} />

        {/* Static pages */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />

        {/* Profile completion */}
        <Route path="/complete-profile" element={<CompleteProfile />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/file/:fileId"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/folder/:folderId"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Catch all - redirect to root */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <AppProvider>
      <PreferencesProvider>
        <TutorialProvider>
          <AppRouter />
          <NotificationContainer />
        </TutorialProvider>
      </PreferencesProvider>
    </AppProvider>
  );
}

export default App;
